<template>
    <Navbar :isDark="false" />

    <!-- CONTENT -->
    <section class="pt-8 pt-md-11 pb-8 pb-md-14">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md">

                    <!-- Heading -->
                    <h1 class="display-4 mb-2">
                        Datenschutzerklärung
                    </h1>

                    <!-- Text -->
                    <p class="fs-lg text-gray-700 mb-md-0">
                        Stand: 22.07.2026
                    </p>

                </div>
            </div> <!-- / .row -->
            <div class="row">
                <div class="col-12">

                    <!-- Divider -->
                    <hr class="my-6 my-md-8">

                </div>
            </div> <!-- / .row -->
            <div class="row">
                <div class="col-12 col-md-8">

                    <p class="fs-lg text-gray-800 mb-6 mb-md-8">
                        Mit den folgenden Informationen gibt AllDayCare Ihnen einen Überblick über die Verarbeitung
                        Ihrer personenbezogenen Daten durch unser Unternehmen. Weiter informieren wir Sie über Ihre
                        Rechte aus dem Datenschutzrecht.
                    </p>

                    <h3 class="mb-5">
                        1. Informationen über die Verarbeitung personenbezogener Daten
                    </h3>

                    <p class="text-gray-800">
                        a) Nachfolgend informieren wir Sie über die Erhebung von personenbezogenen Daten bei Besuch/Nutzung
                        unserer Webapplikation <strong>AllDayCare</strong> und unserer mobilen Applikation
                        <strong>AllDayCareMobile</strong>.
                    </p>

                    <p class="text-gray-800">
                        Unter personenbezogenen Daten sind nach Art. 4 Nr. 1 EU-Datenschutz-Grundverordnung (DSGVO) alle
                        Informationen zu verstehen, die sich auf eine identifizierte oder identifizierbare natürliche
                        Person beziehen. Als identifizierbar wird eine natürliche Person angesehen, die direkt oder
                        indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer,
                        zu Standortdaten, zu einer Online-Kennung oder zu einem oder mehreren besonderen Merkmalen
                        identifiziert werden kann, die Ausdruck der physischen, physiologischen, genetischen,
                        psychischen, wirtschaftlichen, kulturellen oder sozialen Identität dieser Person sind.
                    </p>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        b) Verantwortlicher im Sinne des Art. 4 Nr. 7 DSGVO ist AllDayCare, Arheilger Woogstr. 6 64291 Darmstadt -
                        info@alldaycare.de.
                    </p>

                    <h3 class="mb-5 mt-7">
                        2. Kontakt in Datenschutzfragen
                    </h3>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Wir sind gesetzlich nicht zur Bestellung eines Datenschutzbeauftragten verpflichtet und haben
                        daher keinen benannt. Bei Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte erreichen Sie
                        uns per E-Mail unter
                        <a href="mailto:datenschutz@alldaycare.de">datenschutz@alldaycare.de</a> oder postalisch unter
                        AllDayCare - Datenschutz - Arheilger Woogstr. 6- 64291 Darmstadt.
                    </p>

                    <h3 class="mb-5 mt-7">
                        3. Datenkategorien, Zwecke und Rechtsgrundlagen der Verarbeitung Ihrer personenbezogenen Daten
                    </h3>

                    <p class="text-gray-800">
                        Wir verarbeiten folgende Ihrer personenbezogenen Daten:
                    </p>

                    <p class="text-gray-800">
                        a) Besuch und Nutzung unserer Internetseite:<br>
                        Bei der reinen informatorischen Nutzung unserer Internetseite, verarbeiten wir lediglich die
                        personenbezogenen Daten, welche Ihr Browser an unseren Server übermittelt. Dabei handelt es sich
                        um Daten, die für unser Unternehmen technisch erforderlich sind, um Ihnen unsere Internetseite
                        anzuzeigen und die Sicherheit und Stabilität zu gewährleisten auf Rechtsgrundlage nach Art. 6
                        Abs. 1 Satz 1 lit. f DSGVO:
                    </p>

                    <ul class="text-gray-800 mb-6">
                        <li>IP-Adresse</li>
                        <li>Datum und Uhrzeit</li>
                        <li>Browser</li>
                    </ul>

                    <p class="text-gray-800">
                        b) Registrierung auf unserer Internetseite:<br>
                        Bei der Registrierung auf unserer Internetseite, erheben wir die personenbezogenen Daten, welche
                        wir zur Durchführung für Ihre Bestellung oder einer anderen Leistung für Sie benötigen. Im
                        Einzelnen sind dies folgende Daten:
                    </p>

                    <ul class="text-gray-800 mb-6 mb-md-8">
                        <li>Anrede</li>
                        <li>Vor- und Nachname</li>
                        <li>Adressdaten</li>
                        <li>Geburtsdatum</li>
                        <li>Bestelldaten</li>
                        <li>Zahlungsdaten</li>
                    </ul>

                    <h3 class="mb-5 mt-7">
                        3.1. Datenverarbeitung im Rahmen der Analyse und Behebung von Fehlern
                    </h3>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Im Rahmen von Fehleranalysen und -behebungen verarbeiten wir Fehlerberichte und Log-Dateien,
                        die - je nach Fehler im Einzelfall - die von Ihnen in AllDayCare gespeicherten Daten zum Inhalt
                        haben können. Hiervon können die Datenkategorien nach Ziffer 3b umfasst sein, aber auch solche
                        Daten von Dritten, die wir für Sie auf der Grundlage eines Auftragsverarbeitungsvertrags
                        verarbeiten.
                    </p>

                    <h3 class="mb-5 mt-7">
                        3.2. Erfassung von Nutzerinteraktionen
                    </h3>

                    <p class="text-gray-800">
                        Wir möchten Sie bei Ihrer Arbeit in AllDayCare durch passende Tipps und Gebrauchshinweise sowie
                        durch die zielgerichtete Bereitstellung von Support bestmöglich unterstützen. Aus diesem Grund
                        erfassen wir bestimmte Ereignisse in AllDayCare durch das Tracking von Nutzerinteraktionen
                        innerhalb der Software. In diesem Zusammenhang verarbeiten wir die folgenden Daten von Ihnen:
                    </p>

                    <ul class="text-gray-800 mb-6 mb-md-8">
                        <li>Name</li>
                        <li>Softwareversion</li>
                        <li>Datum und Uhrzeit</li>
                        <li>ggf. weitere innerhalb von AllDayCare erfasste statistische Daten</li>
                    </ul>

                    <h3 class="mb-5 mt-7">
                        3.3. Kontaktaufnahme, Terminvereinbarung und Onboarding
                    </h3>

                    <p class="text-gray-800">
                        Wenn Sie über unsere Internetseite Kontakt mit uns aufnehmen, eine Terminanfrage stellen, den
                        Onboarding-Prozess durchlaufen oder eine Anfrage über unser Hilfe-Center senden, verarbeiten wir
                        die von Ihnen dabei angegebenen Daten (z. B. Anrede, Name, E-Mail-Adresse, Telefonnummer sowie
                        den Inhalt Ihrer Anfrage), um Ihr Anliegen zu bearbeiten und mit Ihnen in Kontakt zu treten.
                    </p>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Rechtsgrundlage ist Art. 6 Abs. 1 Satz 1 lit. b DSGVO, soweit Ihre Anfrage auf den Abschluss
                        oder die Durchführung eines Vertrags gerichtet ist, andernfalls unser berechtigtes Interesse an
                        der Beantwortung Ihrer Anfrage nach Art. 6 Abs. 1 Satz 1 lit. f DSGVO. Soweit Sie uns hierzu
                        eine Einwilligung erteilt haben, ist Rechtsgrundlage Art. 6 Abs. 1 Satz 1 lit. a DSGVO.
                    </p>

                    <h3 class="mb-5 mt-7">
                        3.4. Hosting und Bereitstellung der Internetseite
                    </h3>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Unsere Internetseite sowie die zugehörigen Anwendungsdienste werden bei Microsoft
                        (Microsoft Azure) in Rechenzentren innerhalb der Europäischen Union gehostet. Microsoft
                        verarbeitet die Daten ausschließlich weisungsgebunden in unserem Auftrag auf Grundlage eines
                        Auftragsverarbeitungsvertrags gemäß Art. 28 DSGVO. Rechtsgrundlage für den Einsatz des
                        Hosting-Dienstleisters ist unser berechtigtes Interesse an einer sicheren und effizienten
                        Bereitstellung unserer Internetseite nach Art. 6 Abs. 1 Satz 1 lit. f DSGVO.
                    </p>

                    <h3 class="mb-5 mt-7">
                        3.5. Cookies und lokale Speichertechniken
                    </h3>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Wir setzen auf unserer Internetseite ausschließlich technisch notwendige Cookies bzw.
                        vergleichbare Speichertechniken (z. B. den lokalen Speicher Ihres Browsers) ein, die für den
                        Betrieb und die Grundfunktionen der Seite erforderlich sind. Diese sind nach § 25 Abs. 2 TDDDG
                        einwilligungsfrei; Rechtsgrundlage für die damit verbundene Datenverarbeitung ist Art. 6 Abs. 1
                        Satz 1 lit. f DSGVO. Einwilligungspflichtige Cookies zu Analyse-, Tracking- oder
                        Marketingzwecken setzen wir nicht ein.
                    </p>

                    <h3 class="mb-5 mt-7">
                        4. Empfänger Ihrer personenbezogenen Daten
                    </h3>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Eine Weitergabe Ihrer personenbezogenen Daten an Dritte zu deren eigenen Zwecken findet nicht
                        statt. Zur Bereitstellung und zum Betrieb unserer Internetseite setzen wir sorgfältig
                        ausgewählte Auftragsverarbeiter (insbesondere unseren Hosting- und IT-Dienstleister, siehe
                        Ziffer 3.4) ein, die Ihre Daten ausschließlich weisungsgebunden in unserem Auftrag und auf
                        Grundlage eines Auftragsverarbeitungsvertrags nach Art. 28 DSGVO verarbeiten. Eine Weitergabe an
                        Behörden oder sonstige Stellen erfolgt nur, soweit wir hierzu gesetzlich verpflichtet sind.
                    </p>

                    <h3 class="mb-5 mt-7">
                        5. Übermittlung Ihrer Daten in ein Drittland oder an eine internationale Organisation
                    </h3>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Eine Datenübermittlung in Länder außerhalb der Europäischen Union bzw. des Europäischen
                        Wirtschaftsraum findet nicht statt.
                    </p>

                    <h3 class="mb-5 mt-7">
                        6. Dauer der Speicherung Ihrer personenbezogenen Daten
                    </h3>

                    <p class="text-gray-800">
                        Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen
                        Verarbeitungszwecke erforderlich ist. Maßgebliche Kriterien für die Speicherdauer sind
                        insbesondere die Dauer der Geschäftsbeziehung, bestehende gesetzliche Aufbewahrungsfristen sowie
                        die Erforderlichkeit zur Durchsetzung, Ausübung oder Verteidigung von Rechtsansprüchen.
                    </p>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Nach Wegfall des jeweiligen Verarbeitungszwecks und Ablauf etwaiger gesetzlicher
                        Aufbewahrungsfristen werden die Daten gelöscht oder anonymisiert.
                    </p>

                    <h3 class="mb-5 mt-7">
                        6.1 Wie Sie die Löschung Ihrer Daten veranlassen können
                    </h3>

                    <p class="text-gray-800">
                        Wenn Sie die Löschung Ihrer personenbezogenen Daten aus unserer Webapplikation AllDayCare oder
                        unserer mobilen Applikation AllDayCareMobile wünschen, können Sie uns jederzeit unter
                        <a href="mailto:datenschutz@alldaycare.de">datenschutz@alldaycare.de</a> kontaktieren.
                    </p>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Wir bearbeiten Ihren Antrag im Rahmen der gesetzlichen Vorgaben. Sofern der Löschung keine
                        gesetzlichen Aufbewahrungspflichten entgegenstehen, werden Ihre Daten gelöscht. Andernfalls
                        werden die Daten zunächst für eine weitere Verarbeitung gesperrt und nach Ablauf der gesetzlichen
                        Aufbewahrungsfrist gelöscht.
                    </p>

                    <h3 class="mb-5 mt-7">
                        7. Ihre Rechte
                    </h3>

                    <p class="text-gray-800">
                        Sie haben gegenüber unserem Unternehmen die folgenden Rechte im Hinblick auf Ihre
                        personenbezogenen Daten:
                    </p>

                    <ul class="text-gray-800 mb-6">
                        <li>Recht auf Auskunft nach Art. 15 DSGVO</li>
                        <li>Recht auf Berichtigung nach Art. 16 DSGVO oder Löschung nach Art. 17 DSGVO</li>
                        <li>Recht auf Einschränkung der Verarbeitung nach Art. 18 DSGVO</li>
                        <li>Recht auf Datenübertragbarkeit nach Art. 20 DSGVO</li>
                        <li>Recht auf Widerspruch gegen die Verarbeitung nach Art. 21 DSGVO</li>
                        <li>Recht auf Widerruf einer erteilten Einwilligung nach Art. 7 Abs. 3 DSGVO</li>
                        <li>Recht auf Beschwerde bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten nach Art. 77 DSGVO</li>
                    </ul>

                    <p class="text-gray-800">
                        Widerspruchsrecht: Soweit wir Ihre personenbezogenen Daten auf Grundlage unseres berechtigten
                        Interesses nach Art. 6 Abs. 1 Satz 1 lit. f DSGVO verarbeiten, haben Sie das Recht, aus Gründen,
                        die sich aus Ihrer besonderen Situation ergeben, jederzeit Widerspruch gegen diese Verarbeitung
                        einzulegen.
                    </p>

                    <p class="text-gray-800">
                        Widerrufsrecht: Eine uns erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft
                        widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt hiervon
                        unberührt.
                    </p>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Geltendmachung Ihrer Rechte: Wenden Sie sich zur Ausübung aller Ihrer zuvor genannten Rechte
                        bitte an die oben unter Ziffer 1b) angegebene Anschrift.
                    </p>

                    <h3 class="mb-5 mt-7">
                        8. Pflicht zur Bereitstellung von personenbezogenen Daten
                    </h3>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Im Allgemeinen können Sie unsere Internetseite aufrufen und einsehen, ohne personenbezogene Daten
                        anzugeben. Wenn Sie allerdings eine Registrierung vornehmen, müssen Sie bestimmte
                        personenbezogene Daten (siehe Punkt 3b) angeben. Ohne diese Daten werden wir nicht in der Lage
                        sein, Ihre Anfrage zu bearbeiten bzw. den Vertrag zu erfüllen.
                    </p>

                    <h3 class="mb-5 mt-7">
                        9. Automatisierte Entscheidungsfindung einschließlich Profiling
                    </h3>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Wir nutzen auf unserer Internetseite keine automatisierte Entscheidungsfindung einschließlich
                        Profiling.
                    </p>

                    <h3 class="mb-5 mt-7">
                        10. Datensicherheit
                    </h3>

                    <p class="text-gray-800 mb-6 mb-md-8">
                        Wir verwenden innerhalb des Websitebesuchs das verbreitete TLS-Verfahren (Transport Layer
                        Security) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die Ihr Browser
                        unterstützt, um die von Ihnen übermittelten Daten gegen unbefugten Zugriff zu schützen. Eine
                        verschlüsselte Verbindung erkennen Sie an der Zeichenfolge „https://“ in der Adresszeile Ihres
                        Browsers.
                    </p>

                    <h3 class="mb-5 mt-7">
                        11. Aktualität und Änderung dieser Datenschutzerklärung
                    </h3>

                    <p class="text-gray-800 mb-0">
                        Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Juli 2026. Durch die
                        Weiterentwicklung unserer Internetseite oder aufgrund geänderter gesetzlicher bzw. behördlicher
                        Vorgaben kann es notwendig werden, diese Datenschutzerklärung anzupassen. Die jeweils aktuelle
                        Fassung können Sie jederzeit auf dieser Seite abrufen.
                    </p>
                </div>
                <div class="col-12 col-md-4 d-print-none">

                    <NeedHelpComponent />

                </div>
            </div> <!-- / .row -->
        </div> <!-- / .container -->
    </section>
</template>

<script>
import Navbar from '@/components/Shared/NavBar.vue'
import NeedHelpComponent from '@/components/NeedHelpComponent.vue';

export default {
    components: {
        Navbar,
        NeedHelpComponent
    },
    mounted() {
        document.title = 'Datenschutzerklärung';
    }
}
</script>